import React from "react";
import { NumberOrderApi } from "../../../../../../services/Api/Public/types";
import NumberSystemCardMobile from "./NumberSystemCardMobile";

interface Props {
	items: NumberOrderApi[];
	title: string;
}

const NumberSystemSectionMobile = ({ items, title }: Props) => {
	return (
		<div className="d-flex flex-column number-system-section-mobile">
			<h6>{title}</h6>
			<div className="d-flex flex-column gap-2">
				{items.map((item) => (
					<NumberSystemCardMobile key={item.id} item={item} />
				))}
			</div>
		</div>
	);
};

export default NumberSystemSectionMobile;
